import { render, staticRenderFns } from "./q4.vue?vue&type=template&id=5a6e34bb&scoped=true&"
import script from "./q4.vue?vue&type=script&lang=js&"
export * from "./q4.vue?vue&type=script&lang=js&"
import style0 from "./q4.vue?vue&type=style&index=0&id=5a6e34bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6e34bb",
  null
  
)

export default component.exports